module.exports = __webpack_public_path__ + "static/img/USC-Village_thumbnail.93cfd6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/USC-Village_thumbnail.jpg
// module id = BoYu
// module chunks = 1